/** @format */

import { ItemLoaders } from '../../core/loaders/ItemLoaders';
import Filter from '../../interfaces/forms/Filter';
import Order from '../../interfaces/forms/Order';
import { IndicatedRange, IndicatedRangeCollectionInterface } from '../../interfaces/platform/IndicatedRange';
import { FormGeneralHelper } from '../../helpers/FormGeneral';
import { HeaderCheckBoxSelectListElement } from '../../views/lib/search/listTableHeader/HeaderCheckBoxSelectList';

const _ = require('underscore');

export type LoadIndicatedRangeType = {
    callback: () => void;
    filters: Array<Filter>;
    orders: Array<Order>;
};

export class IndicatedRangeLoader {
    private itemLoaders: ItemLoaders;

    private indicatedRanges: IndicatedRangeCollectionInterface | null;

    private indicatedRangeHeaderList: Array<HeaderCheckBoxSelectListElement> | null;

    constructor(itemLoader: ItemLoaders) {
        this.itemLoaders = itemLoader;
        this.indicatedRanges = null;
        this.indicatedRangeHeaderList = null;
    }

    loadIndicatedRange = (params: LoadIndicatedRangeType): void => {
        this.itemLoaders.getListWithCallback(
            FormGeneralHelper.getByUri(FormGeneralHelper.getPath('/indicated_ranges')),
            'indicated_range_item_loaders_class',
            params.filters,
            params.orders,
            (data: IndicatedRangeCollectionInterface): void => {
                this.indicatedRanges = data;
                this.indicatedRangeHeaderList = null;
                params.callback();
            },
            { propagateDataToCallback: true, dispatchAfterCallback: false }
        );
    };

    getHeaderList = (): Array<HeaderCheckBoxSelectListElement> => {
        if (!this.indicatedRangeHeaderList) {
            const list: Array<HeaderCheckBoxSelectListElement> = [];
            if (!this.indicatedRanges || this.indicatedRanges['hydra:totalItems'] === 0) {
                return list;
            }
            this.indicatedRanges['hydra:member'].map((item: IndicatedRange) => {
                list.push({ name: item.mainname, value: item.id });
            });
            this.indicatedRangeHeaderList = list;
        }
        return this.indicatedRangeHeaderList;
    };

    getItemById = (indicatedRangeId: number): IndicatedRange | null => {
        if (this.indicatedRanges) {
            return _.find(this.indicatedRanges?.['hydra:member'], (item: IndicatedRange) => {
                return item.id === indicatedRangeId;
            });
        }
        return null;
    };

    getName = (indicatedRangeId: number): string | null => {
        const obj = this.getItemById(indicatedRangeId);
        if (!obj) {
            return null;
        }
        return obj.mainname;
    };
}
